import { Options } from '../../shared/models/lookup-master/lookup-master.model';

export class DateOptionsModel {
  constrctor() {
    this.days = [];
    this.months = [];
    this.years = [];
  }
  days: Options[];
  months: Options[];
  years: Options[];
}
